export default __webpack_public_path__ + "static/media/wave-door.11ca5a04.gif";